import styled from "@emotion/styled";
import { useState } from "react";
import { Button, colors, TextField } from "ui";

const Wrapper = styled.div<{ noMargin?: boolean }>`
  margin-top: ${({ noMargin }) => (noMargin ? 0 : "150px")};
  text-align: center;
  background: ${colors.pink400};
  padding: 20px 40px;
  border-radius: 16px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  h1 {
    font-weight: 500;
    color: white;
    @media (max-width: 700px) {
      margin-bottom: 0px;
    }
  }

  p {
    @media (max-width: 700px) {
      margin-bottom: 0px;
    }
  }

  button {
    margin: 20px auto 30px;
    width: 40%;
  }
`;

const Sections = styled.div`
  display: flex;
  gap: 40px;
  margin-bottom: 40px;

  @media (max-width: 700px) {
    gap: 20px;
    flex-direction: column;
    margin-bottom: 10px;
  }
`;

const Section = styled.div`
  flex: 1;
  display: flex;

  flex-direction: column;
  align-items: center;
`;

const P = styled.p`
  text-align: left;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 1.25px;
  color: white;
`;

const InterestForm = ({ noMargin }: { noMargin?: boolean }) => {
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
  });

  const sendEmail = () => {
    const emailContent = `
      Jag är intresserad av Sublyfe och vill gärna höra mer!

      Namn: ${data.name}
      Email: ${data.email}
      Tel: ${data.phone}
      Salong: ${data.company}
    `;

    window.open(
      `mailto:${
        process.env.NEXT_PUBLIC_SUPPORT_EMAIL
      }?subject=Jag vill veta mer om Sublyfe!&body=${encodeURIComponent(
        emailContent
      )}`
    );
  };

  return (
    <Wrapper id="interest-form" noMargin={noMargin}>
      <h1>Kom igång med Sublyfe</h1>
      <Sections>
        <Section>
          <P>
            Du är ett steg ifrån en demo av Sublyfe. Fyll i formuläret och låt
            en av våra experter guida dig med rådgivning och inspiration om hur
            Sublyfe kan höja din verksamhets omsättning. Ta klivet mot en mer
            framgångsrik frisörsalong redan idag!
          </P>
        </Section>
        <Section>
          <TextField
            variant="outlined"
            label="Namn"
            type="text"
            value={data.name}
            fullWidth
            margin="normal"
            onChange={(e) => setData({ ...data, name: e.target.value })}
          />
          <TextField
            variant="outlined"
            label="Email"
            type="text"
            value={data.email}
            fullWidth
            margin="normal"
            onChange={(e) => setData({ ...data, email: e.target.value })}
          />
          <TextField
            variant="outlined"
            label="Telefonnummer"
            type="text"
            value={data.phone}
            fullWidth
            margin="normal"
            onChange={(e) => setData({ ...data, phone: e.target.value })}
          />
          <TextField
            variant="outlined"
            label="Salongsnamn"
            type="text"
            value={data.company}
            fullWidth
            margin="normal"
            onChange={(e) => setData({ ...data, company: e.target.value })}
          />
        </Section>
      </Sections>
      <Button
        gid="button-interestform-send"
        aria-label="Skicka"
        variant="contained"
        onClick={sendEmail}
      >
        Skicka
      </Button>
    </Wrapper>
  );
};

export default InterestForm;
